import { FunctionComponent, memo, useMemo } from 'react';
import { StoryCardPollContent, StoryCardVideoGalleryItem } from '../../../../services';
import { getCssVar } from '../../../utils';
import { PinnedIcon } from '../../PinnedIcon';
import { PollOptions } from '../../PollOptions';
import { UserMentionPreview } from '../../UserMentionPreview';
import { FeedCardImageCommon } from '../FeedCardImageCommon';
import { FeedCardMargin } from '../FeedCardMargin';
import { FeedCardVideoCommon } from '../FeedCardVideoCommon';
import { FeedCardProps } from '../model';

import classes from './FeedCardPollCommon.module.scss';

export const FeedCardPollCommon: FunctionComponent<FeedCardProps> = memo(({ card, chatId }) => {
  const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, mentionedUsers } = card;

  const { headline, text, gallery } = content as StoryCardPollContent;

  const media = useMemo(() => {
    if (!Boolean(gallery.length)) {
      return null;
    }

    if (Boolean((gallery[0] as StoryCardVideoGalleryItem).video)) {
      return <FeedCardVideoCommon card={card} />;
    }

    return <FeedCardImageCommon card={card} />;
  }, [card, gallery]);

  const HeadlineTag = chatId ? 'div' : 'h2';

  return (
    <FeedCardMargin top left right>
      <div className={classes['poll']}>
        <PinnedIcon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          color={getCssVar('--base-link-text-color')}
        />

        {headline && <HeadlineTag className={classes['poll__headline']}>{headline}</HeadlineTag>}

        <UserMentionPreview mentionedUsers={mentionedUsers} openProfile />

        {media && <div className={classes['poll__media']}>{media}</div>}

        {text && <div className={classes['poll__text']}>{text}</div>}

        <PollOptions card={card} />
      </div>
    </FeedCardMargin>
  );
});
